var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4C5.383 4 0 9.383 0 16C0 22.617 5.383 28 12 28H24V16C24 9.383 18.617 4 12 4ZM13 23H11V21H13V23ZM13.928 16.505C13.46 16.764 13 17.631 13 18.257V19H11V18.257C11 17.068 11.734 15.432 12.962 14.754C13.726 14.333 14.12 13.499 13.967 12.629C13.829 11.843 13.157 11.171 12.37 11.033C11.764 10.926 11.176 11.08 10.715 11.467C10.26 11.849 10 12.407 10 13H8C8 11.815 8.521 10.698 9.429 9.936C10.337 9.174 11.538 8.861 12.716 9.063C14.329 9.346 15.654 10.67 15.937 12.284C16.235 13.982 15.428 15.679 13.928 16.505Z",
    fill: "#FF7D45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.b2ececfa8747b6857c4518a442faedee.svg";
export { ForwardRef as ReactComponent };